import { z } from 'zod';

const billingStateSchema = z.enum(['PAYING', 'TRIALING', 'TRIAL_EXPIRED', 'INACTIVE', 'UNKNOWN']);

export const billingAccountSchema = z.object({
    id: z.string(),
    name: z.string(),
    billingState: billingStateSchema,
    planCode: z.string().optional(),
    seatsPaid: z.number().optional(),
    billableAssetsLimit: z.number().optional(),
    trialStart: z.string().optional(),
    trialEnd: z.string().optional(),
    locked: z.boolean(),
    lockReason: z.string().optional(),
    billingStatus: z.string().optional(),
    billingEntitlementsVersion: z.number().optional(),
    updatedAt: z.string().optional(),
});

export type BillingState = z.infer<typeof billingStateSchema>;
export type BillingAccount = z.infer<typeof billingAccountSchema>;
